export const UkI18n = {
  Cancel: '',
  OK: '',
  'Item #{{id}}': '',
  Close: '',
  'Create new item': '',
  Create: '',
  'Update item #{{id}}': '',
  Save: '',
  'Delete item #{{id}}': '',
  'Do you really want to delete item?': '',
  Delete: '',
  'Select content type': '',
  Select: '',
  'Delete permission': '',
  'Do you really want to delete permission "{{title}}" from group?': '',
  'Select permissions for append to group': '',
  Append: '',
  'Delete group': '',
  'Do you really want to delete group "{{title}}" from user?': '',
  'Select groups for append to user': '',
  'Sign in': '',
  Authorization: '',
  'Sign up': '',
  Registration: '',
  Yes: '',
  'Sign out': '',
  'Do you really want to leave?': '',
  Email: '',
  Password: '',
  'Confirm password': '',
  Info: '',
  Error: '',
  'Error Log': '',
  'No data': '',
  'Loading...': '',
  Action: '',
  Language: '',
  'Split button!': '',
  Menu: ''
};
